/**
 * Loads script tags when they're scrolled into view.
 */

const SELECTOR = ".js-script-in-viewport";

const loadScript = ($el: HTMLElement) => {
  const src = $el.getAttribute("data-src");

  if (!src) {
    return;
  }

  const script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);
};

const scriptInViewport = () => {
  if (typeof IntersectionObserver === "undefined") {
    document.querySelectorAll(SELECTOR).forEach(($el: HTMLElement) => {
      loadScript($el);
    });

    return;
  }

  const checkEntry = (entry: IntersectionObserverEntry) => {
    const $entry = entry.target as HTMLElement;

    if (entry.isIntersecting) {
      loadScript($entry);

      observer.unobserve($entry);

      return;
    }
  };

  const callback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(checkEntry);
  };

  const observer = new IntersectionObserver(callback, {
    rootMargin: "0px",
    threshold: 0
  });

  document.querySelectorAll(SELECTOR).forEach(($el: Element) => {
    observer.observe($el as HTMLElement);
  });
};

export default scriptInViewport;
